import React from 'react';
import '../App.css';

function Footer() {

    return (
        <div className="footer-wrapper">
            <p>Copyright @ 2026 Hank Blaustein, Inc. All Rights Reserved.</p>
            <p>Website created by <a href="mailto:pugliesegerard@gmail.com?subject=Website%20Inquiry">Gerard Pugliese</a></p>
        </div>
    );
}

export default Footer;
